import {
  DISPOSAL_LOADING,
  GET_DISPOSAL,
  GET_DISPOSAL_SUCCESS,
  GET_DISPOSAL_FAIL,
  ADD_DISPOSAL_SUCCESS,
  ADD_DISPOSAL_FAIL,
  DELETE_DISPOSAL_SUCCESS,
  DELETE_DISPOSAL_FAIL,
  UPDATE_DISPOSAL_SUCCESS,
  UPDATE_DISPOSAL_FAIL,
  DISPOSAL_RESET,
  DISPOSAL_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  disposals: [],
  disposalAdded: {},
  error: {},
};

const Disposal = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DISPOSAL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_DISPOSAL:
          return {
            ...state,
            disposals: action.payload.data,
            isDisposalCreated: false,
            isDisposalSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_DISPOSAL_FAIL:
      switch (action.payload.actionType) {
        case GET_DISPOSAL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isDisposalCreated: false,
            isDisposalSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_DISPOSAL: {
      return {
        ...state,
        isDisposalCreated: false,
        loading: true,
      };
    }

    case DISPOSAL_LOADING: {
      return {
        ...state,
        isDisposalCreated: false,
        loading: true,
      };
    }

    case ADD_DISPOSAL_SUCCESS:
      return {
        ...state,
        isDisposalCreated: true,
        loading: false,
        disposals: [action.payload.data, ...state.disposals],
        disposalAdded: action.payload.data,
      };

    case ADD_DISPOSAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_DISPOSAL_SUCCESS:
      return {
        ...state,
        loading: false,
        disposals: state.disposals.filter(
          disposal => disposal.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_DISPOSAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_DISPOSAL_SUCCESS:
      return {
        ...state,
        loading: false,
        disposals: state.disposals.map(disposal =>
          disposal.id.toString() === action.payload.data.id.toString() ? { ...disposal, ...action.payload.data } : disposal
        ),
      };

    case UPDATE_DISPOSAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DISPOSAL_RESET_CREATE:
      return {
        ...state,
        isDisposalCreated: false,
      };

    case DISPOSAL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Disposal;